import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

const elem = document.getElementById('root')
if (!elem) throw new Error('No elem')

const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

createRoot(elem).render(app)
